"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../..");

var _icons = require("../../../icons");

var _buttonModule = _interopRequireDefault(require("./button.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var Wrapper = _ref.wrapper,
      size = _ref.size,
      color = _ref.color,
      type = _ref.type,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["wrapper", "size", "color", "type", "children", "className"]);

  var wrapperClassName = (0, _react.useMemo)(function () {
    return [_buttonModule.default.wrapper, _buttonModule.default[size], _buttonModule.default[type], _buttonModule.default[color]].join(" ");
  }, [size, type, color]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    className: wrapperClassName
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: _buttonModule.default.text
  }, /*#__PURE__*/_react.default.createElement(_.Text, {
    size: size
  }, children)), type === "default" && /*#__PURE__*/_react.default.createElement("div", {
    className: _buttonModule.default.icon
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowRightIcon, {
    className: _buttonModule.default.svg
  })));
};

exports.Button = Button;
Button.defaultProps = {
  size: "md",
  color: "primary",
  type: "default",
  wrapper: "button",
  onClick: function onClick() {}
};
Button.propTypes = {
  onClick: _propTypes.default.func,
  size: _propTypes.default.oneOf(["sm", "md", "lg"]),
  type: _propTypes.default.oneOf(["default", "special"]),
  wrapper: _propTypes.default.elementType
};